export interface AgentAction {
    type: 'OPEN_MODAL' | 'NAVIGATE' | 'API_CALL' | 'COPY_TEXT';
    label?: string;
    payload: any;
}

export interface AgentWidgetItem {
    text?: string;
    subText?: string;
    icon?: string;
    label?: string; // For buttons
    action?: AgentAction; // Action for this specific item
}

export interface AgentWidget {
    type: 'card' | 'list' | 'button_group';
    title?: string;
    subtitle?: string;
    description?: string;
    status?: 'success' | 'warning' | 'danger' | 'info' | 'critical';
    items?: AgentWidgetItem[];
    actions?: AgentAction[];
}

export interface ChatMessage {
    role: 'user' | 'assistant' | 'system';
    content: string;
    timestamp: Date;
    widgets?: AgentWidget[];
}

export interface AgentResponse {
    response: string;
    widgets?: AgentWidget[];
    history: any[]; // Raw history from backend
    summary?: string;
}
